<script>
import Style from "@/views/layouts/style";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Copass/Greater10/CopasstTable";
import Swal from "sweetalert2";
import newScoresAPI from "../../../../services/newScores/newScoresAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  props: {
    companyID: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CheckModal,
    Style,
    Table,
  },
  data() {
    return {
      title: "1.1.6 Acta de conformación Copasst Vigía de salud",
      items: [
        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "Responsable SG",
          href: "/",
        },
        {
          text: "Registro de responsable sg",
          active: true,
        },
      ],
      dateTo: null,
      dateFrom: null,
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(id = 6) {
      CompanyItemsAPI.getStatus(this.companyID, id)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 6)
        .then((response) => {
          try {
            this.item = response || null;
          } catch (error) {
            this.item = null;
            this.itemStatus = null;
            console.log(error);
          } finally {
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 6,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha actualizado el estado del ítem!",
            type: "error",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          console.log(error);
          setTimeout(() => window.location.reload(), 2000)
        });
    },

    goPage(url) {
      window.location.href = url;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getStatusItem();
  },
};
</script>

<template>
  <div class="row animated animatedFadeInUp fadeInUp">
    <div class="col-md-12">
      <div v-if="!loading">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    La empresa cuenta, de acuerdo con el número de trabajadores
                    con:
                  </p>
                  <p class="text-justify">
                    <b>Vigía en Seguridad y Salud en el Trabajo</b> para
                    empresas de menos de diez (10) de trabajadores.
                  </p>
                  <p class="text-justify">
                    <b>Comité Paritario en Seguridad y Salud en el Trabajo
                      COPASST</b>
                    para empresas de diez (10) o más trabajadores
                  </p>
                  <p class="text-justify">
                    La empresa debe garantizar que se lleve el proceso de
                    convocatoria, inscripción, votaciones y designación de los
                    representantes al comité y almacenar las actas.
                    Mensualmente, los integrantes deben realizar una reunión, en
                    el sistema se puede crear el acta de esta reunión,
                    posteriormente descargarla para hacer firmar por los
                    asistentes
                  </p>
                </CheckModal>
              </div>

              <div class="form-row col-md-6 col-sm-12 pt-1">
                <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                  <b-form-select v-on:change="changeItemStatus(itemStatus)"
                    :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                    class="selectpicker form-control" v-model="itemStatus">
                    <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                    <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                    <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                  </b-form-select>
                  <a :href="`/forms/copasst`" underline class="mx-1">
                    ¿Quién es el Comité del COPASST?
                  </a>
                </b-form-group>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-sm-12 text-right mr-3">
                <button type="button" :disabled="!allowAccess() || !getRole('Crear')" @click="
                  goPage(`/forms/estandares/${companyID}/acta-copasst/${0}`)
                  " class="btn btn-primary mb-2 mb-sm-0">
                  Agregar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>
            </div>
            <Table :companyID="companyID" />
          </div>
        </div>
      </div>

      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
